import React, { useEffect } from "react";
import { imgs } from "../../assets/imgs";
import { icons } from "../../assets/icons";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const PanelActivities = ({
	title = "",
	titleActivity = "",
	activities = [{ title: "", isComplete: false, isCurrentAct: false }],
	buttonText = "",
	actionButton = () => { },
	points = { total: 0, won: 0 },
	insigniaBackground = 0,
}) => {
	useEffect(() => {
		const idSelect = activities.findIndex(((act) => act.isCurrentAct))
		const targetElement = document.getElementById(`task-${idSelect}`);
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: "smooth" });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	// console.log(activities);
	return (
		<div className="fixed z-30 bg-[#00000074] w-full h-full">
			<div className="h-full w-full relative flex justify-center items-center">
				<div className="h-[240px] md:h-[360px] w-[550px] md:w-[700px] bg-white overflow-hidden rounded-[32px] relative">
					<div className="h-[20%] w-full bg-[#282828] flex justify-center items-center">
						<p className="text-white text-[12px] md:text-[16px] font-semibold">{title}</p>
					</div>
					<div className="h-[80%] w-full p-3 md:p-6">
						<div className="w-full h-full grid grid-cols-panelActivities">
							<BodyActivitiesList titleActivity={titleActivity} activities={activities} />
							<BodyPoints points={points} insigniaBackground={insigniaBackground} />
						</div>
					</div>
				</div>
				<div className="absolute bottom-5 right-5">
					<button
						onClick={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
							actionButton()
						}}
						className="boxShadowButtons bg-[#FFC427] text-[12px] md:text-[16px] text-white w-[160px] md:w-[230px] h-[32px] md:h-[40px] py-1 rounded-xl"
					>
						{buttonText}
					</button>
				</div>
			</div>
		</div>
	);
};

const BodyActivitiesList = ({ titleActivity = "", activities = [{ title: "", isComplete: false, isCurrentAct: false }] }) => {
	return (
		<div className="relative overflow-hidden">
			<div className="absolute z-20 h-full w-full py-3 pl-5 pr-2 overflow-hidden">
				<div className="h-full w-full">
					<div className="h-[20%] flex justify-center items-center">
						<p className="text-white text-[12px] md:text-[16px] font-semibold">{titleActivity}</p>
					</div>
					<div className="h-[80%] overflow-y-auto customScrollAct">
						{activities.map((act, index) => {
							let jsonActStyle = {
								styleCheck: "border-[#CDCDCD]",
								styleImg: "opacity-0",
								styleText: "text-white",
							};
							if (!act.isComplete && act.isCurrentAct) {
								jsonActStyle = {
									styleCheck: "border-[#FFC427]",
									styleImg: "opacity-0",
									styleText: "text-[#FFC427] font-semibold",
								};
							}

							if (act.isComplete) {
								jsonActStyle = {
									styleCheck: "border-[#ffffff] bg-green_primary ",
									styleImg: "opacity-100",
									styleText: "text-white",
								};
							}
							return (
								<div key={`${index}-act-panelact`} className="h-12 w-full mt-1 mb-1" id={`task-${index}`}>
									<div className="h-full w-full flex items-center px-2 gap-4 overflow-hidden">
										<div className="h-6 md:px-1 w-[10%] overflow-hidden">
											<div className={`h-full w-full border-[2px] rounded-lg ${jsonActStyle.styleCheck}`}>
												<img
													className={`h-full w-full object-contain ${jsonActStyle.styleImg} `}
													src={icons.arrowmenu}
													alt="flecha"
												/>
											</div>
										</div>
										<div className="w-[90%]">
											<p className={`${jsonActStyle.styleText} text-[10px] md:text-[12px]`}>{act.title}</p>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="absolute z-10 h-full w-full">
				<img className="h-full w-full" src={imgs.blockActivities} alt="act" />
			</div>
		</div>
	);
};

const BodyPoints = ({ points = { total: 0, won: 0 }, insigniaBackground = 0 }) => {
	let selectInsight = {
		backColor: "#589DBA",
		title: "¡Gana una insignia!",
		titleStyle: "text-black",
		backColorInsignia: "bg-backNotAct",
		subtitle: "Completa las actividades obteniendo la mayor cantidad de puntos y gana una insignia.",
		subtitleStyle: "text-red_primary",
	};
	if (insigniaBackground === 1) {
		selectInsight = {
			backColor: "#E3211B",
			title: "Lo sentimos, no obtuviste la insignia.",
			titleStyle: "text-black",
			backColorInsignia: "bg-backActFailure",
			subtitle: "Completa las actividades obteniendo la mayor cantidad de puntos y gana una insignia.",
			subtitleStyle: "text-[#686868]",
		};
	}
	if (insigniaBackground === 2) {
		selectInsight = {
			backColor: "#22C55E",
			title: "¡Felicidades! obtuviste una insignia.",
			titleStyle: "text-blanck",
			backColorInsignia: "bg-backActComplete",
			subtitle: "¡Lograste aprobar las actividades del Subtema.",
			subtitleStyle: "text-[#686868]",
		};
	}
	return (
		<div className="pl-2">
			<div className="h-[30%]">
				<div
					className="h-full w-full rounded-[12px] flex flex-col justify-center items-center"
					style={{ backgroundColor: selectInsight.backColor }}
				>
					<div>
						<p className="text-white text-[14px] md:text-[16px] font-semibold">Puntos acumulados</p>
					</div>
					<div>
						<p className="text-white text-[14px] md:text-[18px] font-bold">
							{points.won}/{points.total}
						</p>
					</div>
				</div>
			</div>
			<div className="h-[70%] overflow-hidden pt-2">
				<div className={`h-full w-full rounded-2xl py-1 px-1 bg-cover bg-center ${selectInsight.backColorInsignia}`}>
					<div className="h-[32%] w-full flex justify-center items-center">
						<p className={`${selectInsight.titleStyle} text-[10px] md:text-[14px] font-bold text-center`}>{selectInsight.title}</p>
					</div>
					<div className="h-[68%] w-full flex justify-center items-center">
						<div className="h-16 w-16 md:h-20 md:w-20 overflow-hidden">
							<img className="h-full w-full object-contain" src={imgs.insignia} alt="insi" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
